import { s__ } from '~/locale';
import NoteableWarning from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/notes/noteable_warning.vue?vue3';
import EmailParticipantsWarning from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/email_participants_warning.vue?vue3';
const ATTACHMENT_REGEXP = /!?\[.*?\]\(\/uploads\/[0-9a-f]{32}\/.*?\)/;
export default {
    name: 'CommentFieldLayout',
    i18n: {
        attachmentWarning: s__('Notes|Attachments are sent by email. Attachments over 10 MB are sent as links to your GitLab instance, and only accessible to project members.'),
        confidentialAttachmentWarning: s__('Notes|Uploaded files will be accessible to anyone with the file URL. Use caution when sharing file URLs.')
    },
    components: {
        EmailParticipantsWarning,
        NoteableWarning
    },
    props: {
        isInternalNote: {
            type: Boolean,
            required: false,
            default: false
        },
        note: {
            type: String,
            required: false,
            default: ''
        },
        noteableData: {
            type: Object,
            required: true
        },
        withAlertContainer: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        containsLink () {
            return ATTACHMENT_REGEXP.test(this.note);
        },
        isLocked () {
            return Boolean(this.noteableData.discussion_locked);
        },
        isConfidential () {
            return Boolean(this.noteableData.confidential);
        },
        hasWarningAbove () {
            return this.isConfidential || this.isLocked;
        },
        hasWarningBelow () {
            return this.showConfidentialAttachmentWarning || this.showAttachmentWarning || this.showEmailParticipantsWarning;
        },
        emailParticipants () {
            return this.noteableData.issue_email_participants?.map(({ email })=>email) || [];
        },
        showEmailParticipantsWarning () {
            return this.emailParticipants.length && !this.isInternalNote;
        },
        showAttachmentWarning () {
            return this.showEmailParticipantsWarning && this.containsLink;
        },
        showConfidentialAttachmentWarning () {
            return (this.isConfidential || this.isInternalNote) && this.containsLink;
        }
    }
};
